import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { RoleAdaptiveLayout } from './layout/RoleAdaptiveLayout';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { FinancialDashboard } from './pages/FinancialDashboard';
import { ParentDashboardPlaceholder } from './pages/ParentDashboardPlaceholder';
import { RequirementsPage } from './pages/RequirementsPage';
import { RequirementDetailPage } from './pages/RequirementDetailPage';
import { CashierGrantsPage } from './pages/CashierGrantsPage';
import { PaymentsPage } from './pages/PaymentsPage';
import { ExpensesPage } from './pages/ExpensesPage';
import { ReportsPage } from './pages/ReportsPage';
import { MyGroupsPage } from './pages/MyGroupsPage';
import { GroupStudentsPage } from './pages/GroupStudentsPage';
import { useAuth, isFinancialLayoutRole } from './auth/AuthProvider';

/**
 * Az /app/ alatti index oldal:
 * a layout már role-adaptív, de a tartalmi oldalt is meg kell választanunk
 * az aktív role alapján.
 */
function AppIndex() {
  const { activeRole } = useAuth();
  return isFinancialLayoutRole(activeRole) ? (
    <FinancialDashboard />
  ) : (
    <ParentDashboardPlaceholder />
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/app" element={<RoleAdaptiveLayout />}>
          <Route index element={<AppIndex />} />
          <Route path="my-groups" element={<MyGroupsPage />} />
          <Route path="groups/:id/students" element={<GroupStudentsPage />} />
          <Route path="requirements" element={<RequirementsPage />} />
          <Route path="requirements/:reqId" element={<RequirementDetailPage />} />
          <Route path="cashier-grants" element={<CashierGrantsPage />} />
          <Route path="payments" element={<PaymentsPage />} />
          <Route path="expenses" element={<ExpensesPage />} />
          <Route path="reports" element={<ReportsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
